import { AllBlogPostsQuery } from "gql/types/graphql";
import { FC } from "react";
import styled from "styled-components";
import { mobile, tablet } from "components/templates/Breakpoints";
import { ResourceCardsSection } from "components/resources/resourceHub/ResourceCardsSection";
import { H2 } from "components/atoms/Heading";
import { ContentType, getReadTimeFromHtml, getStrapiImageByBreakpoint } from "@utils";
import { YuLifeLocale } from "@hooks";

interface RecommendedResourcesProps {
  recommendedResources: any[];
  contentType: ContentType;
  locale: YuLifeLocale;
}

const RecommendedResources: FC<RecommendedResourcesProps> = ({
  recommendedResources,
  contentType,
  locale,
}) => {
  return (
    <>
      {recommendedResources && recommendedResources?.length ? (
        <Margin>
          <Container>
            <Title>You might also like</Title>
            <ResourceCardsSection
              locale={locale}
              cards={recommendedResources.map((resource) => ({
                title: resource.title,
                contentType,
                tag: resource.tags?.data[0]?.attributes.name,
                thumbnailSrc: getStrapiImageByBreakpoint(
                  resource.featuredImage?.data?.attributes?.formats,
                  "small",
                ),
                thumbnailAlt: resource.featuredImage?.data?.attributes?.alternativeText,
                duration: `${getReadTimeFromHtml(resource.post)} min read`,
                slug: resource.slug,
              }))}
            />
          </Container>
        </Margin>
      ) : null}
    </>
  );
};

export default RecommendedResources;

const Margin = styled.div`
  width: 100%;
  padding: 6rem 10.5%;
  padding-top: 0;

  ${tablet} {
    padding: 3.5rem 6%;
  }

  ${mobile} {
    padding: 0 1.5rem 2.5rem 1.5rem;
  }
`;

const Container = styled.div`
  max-width: 70.5rem;
  margin: 0 auto;
`;

const Title = styled(H2)`
  padding: 2rem 0;

  ${mobile} {
    font-size: 2rem;
  }
`;
